// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2fZ-b","question":"Question_question__1ryzx","description":"Question_description__VG6QW"};